// extracted by mini-css-extract-plugin
export default {"inputsContainer":"styles_inputsContainer__65Mte","margin":"styles_margin__JDJhF"};